import { render, staticRenderFns } from "./editService.vue?vue&type=template&id=408da645&scoped=true&"
import script from "./editService.vue?vue&type=script&lang=js&"
export * from "./editService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408da645",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('408da645')) {
      api.createRecord('408da645', component.options)
    } else {
      api.reload('408da645', component.options)
    }
    module.hot.accept("./editService.vue?vue&type=template&id=408da645&scoped=true&", function () {
      api.rerender('408da645', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/components/editService.vue"
export default component.exports